import { createRouter } from '@tanstack/react-router'

import { createGlobalInstance } from '@campai/lib-web/utils/state'
import { applySafeLoader, createErrorRoute } from '@campai/lib-web/routes'

import { appRoute } from '@/app'
import { createOrganizationRoute } from '@/createOrganization'
import { homeRoute } from '@/home'
import { invitationRoute } from '@/invitation'
import { productRoute } from '@/product'
import { profileRoute } from '@/profile'

export const router = createGlobalInstance('router', () => {
    const routeTree = appRoute.addChildren([
        homeRoute,
        profileRoute,
        createOrganizationRoute,
        invitationRoute,
        productRoute,
        createErrorRoute(appRoute),
    ])

    applySafeLoader(routeTree)

    return createRouter({ routeTree, defaultGcTime: 0, scrollRestoration: false })
})

declare module '@tanstack/react-router' {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
    interface Register {
        router: typeof router
    }
}
